import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { LoggedOutHomeImage } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/__internal__/LoggedOutHomeImage/LoggedOutHomeImage";
import * as componentStyles from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/WeMakeItSimpleBanner/styles.css";
import { MIN_WIDTH_BREAKPOINTS } from "@faire/web--source/common/media";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import React from "react";
export var WeMakeItSimpleRightImage = function() {
    var isTabletAndAbove = useViewport().isTabletAndAbove;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(LoggedOutHomeImage, {
                lazyLoad: true,
                responsiveImage: {
                    mobileAndAbove: IImage.build({
                        url: "https://cdn.faire.com/fastly/48793107444445287628bcd1d7e74cb936b8e8e3086cc559f20fba2a9971b301.jpeg"
                    }),
                    tabletAndAbove: IImage.build({
                        url: "https://cdn.faire.com/fastly/5f12fe62a6f9073e2fcc86a838d2328c90baec9d283ff4ef8adff84f7ecf44da.jpeg"
                    }),
                    desktopAndAbove: IImage.build({
                        url: "https://cdn.faire.com/fastly/591072d0058535e7f6ae2406958750224d68f9950cdc5382923711050ba9d6f8.jpeg"
                    }),
                    xLargeAndAbove: IImage.build({
                        url: "https://cdn.faire.com/fastly/6dfffc60b732e950f90c0fa3a24928b518f66ae1190643f01e63054b29f15212.jpeg"
                    })
                },
                optimizeImageOptions: {
                    mobileAndAbove: {
                        width: 375,
                        height: componentStyles.MOBILE_BANNER_HEIGHT
                    },
                    tabletAndAbove: {
                        width: MIN_WIDTH_BREAKPOINTS.TABLET / 2,
                        height: componentStyles.TABLET_BANNER_HEIGHT
                    },
                    desktopAndAbove: {
                        width: MIN_WIDTH_BREAKPOINTS.DESKTOP / 2,
                        height: componentStyles.DESKTOP_BANNER_HEIGHT
                    },
                    xLargeAndAbove: {
                        width: MIN_WIDTH_BREAKPOINTS.XLARGE / 2,
                        height: componentStyles.XLARGE_BANNER_HEIGHT
                    }
                },
                imageStyles: isTabletAndAbove ? {
                    display: "inline",
                    minHeight: "100%"
                } : {}
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "absolute bottom-8 flex flex-col",
                style: {
                    padding: "".concat(getSpacing(0, "4x"))
                },
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansMedium",
                        color: Core.text.inverse,
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "9W46UD",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Annika Huston, Owner of Dotter"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.inverse,
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "hTrpYV",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Los Angeles, California"
                                }
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
